<script>
import RecurrencesCollection from '../components/recurrences/RecurrencesCollection.vue';

export default {
  components: { RecurrencesCollection },
};
</script>